import { render } from "./Storage Bins.vue?vue&type=template&id=305db717"
import script from "./Storage Bins.vue?vue&type=script&lang=js"
export * from "./Storage Bins.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__